module.exports = __webpack_public_path__ + "img/date_retard_24.c934c88c.jpg";